import type { GetTransactionsQueryDto } from "../api/types";
import type { PeriodId } from "./period";

export type FiltersWithPeriod = GetTransactionsQueryDto & {
  period?: PeriodId | null;
};

export const applyFilters = (
  prevParams: URLSearchParams,
  newFilters: FiltersWithPeriod,
): URLSearchParams => {
  const newParams = new URLSearchParams(prevParams);

  // `period` and explicit start/end dates are mutually exclusive in the URL —
  // whichever the caller set wins.
  if (newFilters.period) {
    newParams.set("period", newFilters.period);
    newParams.delete("startDate");
    newParams.delete("endDate");
  } else {
    newParams.delete("period");
    if (newFilters.startDate) newParams.set("startDate", newFilters.startDate);
    else newParams.delete("startDate");

    if (newFilters.endDate) newParams.set("endDate", newFilters.endDate);
    else newParams.delete("endDate");
  }

  newParams.delete("source");
  newFilters.source?.forEach((v) => newParams.append("source", v));

  newParams.delete("expenseType");
  newFilters.expenseType?.forEach((v) => newParams.append("expenseType", v));

  newParams.delete("group");
  newFilters.group?.forEach((v) => newParams.append("group", v));

  newParams.delete("category");
  newFilters.category?.forEach((v) => newParams.append("category", v));

  if (newFilters.merchant) newParams.set("merchant", newFilters.merchant);
  else newParams.delete("merchant");

  if (newFilters.description)
    newParams.set("description", newFilters.description);
  else newParams.delete("description");

  newParams.delete("autoTransactionId");
  newFilters.autoTransactionId?.forEach((v) =>
    newParams.append("autoTransactionId", v),
  );

  if (newFilters.importId) newParams.set("importId", newFilters.importId);
  else newParams.delete("importId");

  if (newFilters.ignored) newParams.set("ignored", "true");
  else newParams.delete("ignored");

  if (newFilters.matchProblem) newParams.set("matchProblem", "true");
  else newParams.delete("matchProblem");

  return newParams;
};

export const countActiveFilters = (filters: FiltersWithPeriod): number => {
  let count = 0;
  if (filters.period) {
    count++;
  } else {
    if (filters.startDate) count++;
    if (filters.endDate) count++;
  }
  if (filters.source?.length) count++;
  if (filters.expenseType?.length) count++;
  if (filters.group?.length) count++;
  if (filters.category?.length) count++;
  if (filters.merchant) count++;
  if (filters.description) count++;
  if (filters.autoTransactionId?.length) count++;
  if (filters.importId) count++;
  if (filters.ignored) count++;
  if (filters.matchProblem) count++;
  return count;
};
